/* eslint-disable sort-keys */
const shared = {
    height: '$avatar',
    width: '$avatar',
}

export const avatar = {
    ...shared,
    boxSizing: 'border-box',
    position: 'relative',
    variants: {
        size: {
            small: {
                height: '$avatarSmall',
                width: '$avatarSmall',
            },
        },
    },
}

export const nativeAvatar = {...shared}

const sharedStatus = {
    backgroundColor: '$statusOpen',
    borderColor: '$statusBorder',
    borderRadius: '$avatarStatus',
    borderStyle: 'solid',
    borderWidth: '$avatarStatus',
    height: '$avatarStatus',
    position: 'absolute' as const,
    variants: {
        status: {closed: {backgroundColor: '$statusClosed'}},
        isGroupQueue: {true: {}},
        groupStatus: {
            positive: {},
            negative: {},
            half: {},
        },
    },
    compoundVariants: [
        {
            groupStatus: 'negative',
            isGroupQueue: true,
            css: {backgroundColor: '$statusClosed'},
        },
        {
            groupStatus: 'half',
            isGroupQueue: true,
            css: {background: 'linear-gradient(90deg, $tableCellStatusPositive 50%, $tableCellStatusNegative 50%)'},
        },
    ],
    width: '$avatarStatus',
}

export const status = {
    ...sharedStatus,
    bottom: '-2px',
    boxSizing: 'border-box',
    right: '-2px',
}

export const nativeStatus = {
    ...sharedStatus,
    bottom: '-2',
    boxSizing: 'border-box',
    right: '-2',
}
